<template>
  <v-autocomplete
    hide-details="auto"
    :items="items"
    v-model="getSetModelItem"
    class="mt-0"
    :label="$t(Option.name)"
    clearable
    :item-text="Option.itemText"
    :item-value="Option.itemValue"
    @change="changeItem()"
    @click:clear="$delete(selected, Option.name)"
    :loading="isLoading"
    :search-input.sync="search"
    :no-data-text="$t('No data available')"
    no-filter
    cache-items
    return-object
    outlined
    dense
  ></v-autocomplete>
</template>
  
  <script>
export default {
  props: ["Option", "selected", "selectedItem"],

  data() {
    return {
      pagesItems: { counter: 10, startCoutner: 0, page: 1 },
      isLoading: false,
      search: null,
      items: [],
      timer: null,
      modelItem: null,
    };
  },
  computed: {
    getSetModelItem: {
      get() {
        return this.modelItem;
      },
      set(newItem) {
        this.modelItem = newItem;
      },
    },
  },
  methods: {
    changeItem() {
      this.$emit("changeItem", this.modelItem);
    },
  },
};
</script>
  
  <style>
</style>